import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Tab, Tabs, Form, Button } from "react-bootstrap";
import {  useNavigate } from 'react-router-dom';
import { LegendFieldComponent, LegendTextareaComponent, IconFieldComponent } from "../../components/fields";
import { ButtonComponent } from "../../components/elements";
import { FileUploadComponent } from "../../components"; 
import PageLayout from "../../layouts/PageLayout";
import { useAuthStore } from "../../store/auth.store.ts";
import Swal from "sweetalert2";
import RutValidator from "../../utils/validateRut";

import { modificarContrasena,modificarMisDatos  } from "../../api/misDatos.ts";

export default function MyAccountPage() {

    const { t } = useContext(TranslatorContext);
    const navigate = useNavigate();

    const setUsuarioStore = useAuthStore((state) => state.setUsuario);
    const [usuario, setUsuario] = useState({});
    const [rut, setRut] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [rutError, setRutError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [disableEditButton, setDisableEditButton] = useState(false);

    // Estados para edición de datos
    const [editData, setEditData] = useState({
        nombre: "",
        apellido: "",
        email: "",
        rut: ""
    });

    const [passwordError, setPasswordErr] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
      
    
    const [formData, setFormData] = useState({
        password: "",
        confirmPassword:''
        });
    

    const [nombrePila, setNombrePila] = useState("");
    const [email, setEmail] = useState("");
    const [emailUsuario, setEmailUsuario] = useState("");
    const [disableSubmitButton, setDisableSubmitButton] = useState(false);

    useEffect(() => {
            setUsuario(useAuthStore.getState().usuario);
            const currentUser = useAuthStore.getState().usuario;
            setRut(currentUser.rut+'-'+currentUser.dv);
            
            // Inicializar datos editables
            setEditData({
                nombre: currentUser.nombre || "",
                apellido: currentUser.apellido || "",
                email: currentUser.email || "",
                rut: (currentUser.rut+'-'+currentUser.dv) || ""
            });
           
    }, [usuario]);

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      };
    
      const handleValidation = (e)=>{
        const passwordInputValue = e.target.value.trim();
        const passwordInputFieldName = e.target.name;
    
        //for password
        if(passwordInputFieldName==='password'){
          const uppercaseRegExp   = /(?=.*?[A-Z])/;
          const lowercaseRegExp   = /(?=.*?[a-z])/;
          const specialCharRegExp = /(?=.*?[#?!@$%^&()*+._-])/;
          const minLengthRegExp   = /.{8,}/;
          const digitsRegExp      = /(?=.*?[0-9])/;
          const passwordLength =      passwordInputValue.length;
          const uppercasePassword =   uppercaseRegExp.test(passwordInputValue);
          const lowercasePassword =   lowercaseRegExp.test(passwordInputValue);
          const specialCharPassword = specialCharRegExp.test(passwordInputValue);
          const minLengthPassword =   minLengthRegExp.test(passwordInputValue);
          const digitsPassword =      digitsRegExp.test(passwordInputValue);
    
          // check password include nombrePila in uppercase
          const nombrePilaInPassword = passwordInputValue.toUpperCase().includes(nombrePila.toUpperCase());
          const emailInPassword = passwordInputValue.toUpperCase().includes(email.toUpperCase());
          const emailUsuarioInPassword = passwordInputValue.toUpperCase().includes(emailUsuario.toUpperCase());
    
          let errMsg ="";
          if(passwordLength===0){
                  errMsg="Debe ingresar una contraseña";
          }else if(!uppercasePassword){
                  errMsg="Debe contener al menos una Mayúscula";
          }else if(!lowercasePassword){
                  errMsg="Debe contener al menos una Minúscula";
          }else if(!specialCharPassword){
                  errMsg="Debe contener al menos un caracter especial";
          }else if(!minLengthPassword){
                  errMsg="Debe contener al menos 8 caracteres";
          }else if(!digitsPassword){
                  errMsg="Debe contener al menos un número";
          }else{
              errMsg="";
          }
          setPasswordErr(errMsg);
        }
        // for confirm password
        if(passwordInputFieldName=== "confirmPassword" || (passwordInputFieldName==="password" && formData.confirmPassword.length>0) ){
          if(formData.confirmPassword!==formData.password)
          {
          setConfirmPasswordError("Las contraseñas no coinciden");
          }else{
          setConfirmPasswordError("");
          }
        }
    }

    // Funciones para edición de datos personales
    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditData({ ...editData, [name]: value });
        
        // Validar email en tiempo real
        if (name === "email") {
            validateEmail(value);
        }
        
        // Validar RUT en tiempo real
        if (name === "rut") {
            validateRut(value);
        }
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setEmailError("Email no válido");
        } else {
            setEmailError("");
        }
    };

    const validateRut = (rut) => {
        if (!rut || rut.trim() === "") {
            setRutError("El RUT es requerido");
        } else if (!RutValidator.validaRut(rut)) {
            setRutError("El RUT ingresado no es válido");
        } else {
            setRutError("");
        }
    };

    const handleToggleEditMode = () => {
        if (editMode) {
            // Cancelar edición
            setEditData({
                nombre: usuario.nombre || "",
                apellido: usuario.apellido || "",
                email: usuario.email || "",
                rut: rut || ""
            });
            setRutError("");
            setEmailError("");
        }
        setEditMode(!editMode);
    };

    const handleGuardarDatos = async () => {
        try {
            setDisableEditButton(true);

            // Validaciones
            if (!editData.nombre?.trim()) {
                Swal.fire({ icon: 'warning', text: 'El nombre es requerido' });
                setDisableEditButton(false);
                return;
            }

            if (!editData.apellido?.trim()) {
                Swal.fire({ icon: 'warning', text: 'El apellido es requerido' });
                setDisableEditButton(false);
                return;
            }

            if (!editData.email?.trim()) {
                Swal.fire({ icon: 'warning', text: 'El email es requerido' });
                setDisableEditButton(false);
                return;
            }

            if (!editData.rut?.trim()) {
                Swal.fire({ icon: 'warning', text: 'El RUT es requerido' });
                setDisableEditButton(false);
                return;
            }

            if (emailError) {
                Swal.fire({ icon: 'warning', text: 'El email no es válido' });
                setDisableEditButton(false);
                return;
            }

            if (rutError) {
                Swal.fire({ icon: 'warning', text: 'El RUT no es válido' });
                setDisableEditButton(false);
                return;
            }

            // Llamar API para actualizar datos (incluir RUT)
            const resultado = await modificarMisDatos(editData.nombre, editData.apellido, editData.email, editData.rut);

            if (!resultado.error) {
                // Actualizar estado global
                // Extraer RUT y DV eliminando puntos
                const [rutSinPuntos, dvExtraido] = editData.rut.replace(/\./g, '').split('-');
                
                const updatedUser = {
                    ...usuario,
                    nombre: editData.nombre,
                    apellido: editData.apellido,
                    email: editData.email,
                    rut: rutSinPuntos,
                    dv: dvExtraido || editData.dv
                };
                setUsuario(updatedUser);
                setUsuarioStore(updatedUser);
                setRut(rutSinPuntos); // Actualizar RUT en estado

                Swal.fire({ icon: 'success', text: 'Datos actualizados correctamente' });
                setEditMode(false);
            } else {
                Swal.fire({ icon: 'warning', text: resultado.msg || 'Error al actualizar datos' });
            }
        } catch (error) {
            Swal.fire({ icon: 'error', text: 'Error al guardar los datos' });
        } finally {
            setDisableEditButton(false);
        }
    };

    const handleSubmit = (e) => {
        
        e.preventDefault();
    
        e.preventDefault();
        try {
          setDisableSubmitButton(true)
    
          // Validar que no exista error de validación. passwordError y confirmPasswordError deben estar vacíos.
          // Además, realizar una doble validación de la cantidad minima de caracteres para evitar que se valide sin ingresar datos en los input.
    
          if(passwordError !== "" || confirmPasswordError !== ""){
            Swal.fire({icon: 'warning', text: "Las contraseñas no cumplen los requisitos mínimos." })
            setDisableSubmitButton(false)
            return;
          }
    
        
    
          modificarContrasena( formData.password, formData.confirmPassword)
          .then((res) => {
            if( res.error === false ) {
                Swal.fire({icon: 'success', text: 'Contraseña actualizada correctamente.'});
              localStorage.setItem("verificationCode", "");
              navigate("/");
            } else {
                Swal.fire({icon: 'warning', text: res.msg })
              setDisableSubmitButton(false)
            }
          })
    
    
        } catch (err) {
            Swal.fire({title: 'Error', text: 'Error al realizar cambio de contraseña. Si el problema persiste contacte al administrador.' })
          setDisableSubmitButton(false)
        }
    
       
      };

   
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Mi Cuenta</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                               
                                <li className="mc-breadcrumb-item">Mi Cuenta</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                <Col xl={12}>
                    <div className="mc-card">
                        <Tabs defaultActiveKey="profile" id="mc" className="mc-tabs">
                            <Tab eventKey="profile" title="Mi Perfil" className="mc-tabpane profile">
                                <div className="mc-tab-card">
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                        <h6 className="mc-tab-card-title">Mis Datos</h6>
                                        <Button 
                                            variant={editMode ? "secondary" : "primary"} 
                                            size="sm"
                                            onClick={handleToggleEditMode}
                                            disabled={disableEditButton}
                                        >
                                            <i className='material-icons' style={{ fontSize: '16px', marginRight: '5px' }}>
                                                {editMode ? 'cancel' : 'edit'}
                                            </i>
                                            {editMode ? 'Cancelar' : 'Editar'}
                                        </Button>
                                    </div>
                                    
                                    {!editMode ? (
                                        // Modo Lectura
                                        <Row>
                                            <Col xl={4}>
                                                <div className="mc-user-avatar-upload">
                                                    <div className="mc-user-avatar">
                                                        <img src="images/454394643_1066147051562693_6889527070463660169_n.jpg" alt="avatar" />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xl={8}>
                                                <Row>
                                                    <Col xl={6}><Form.Control type="text" disabled readOnly title="Nombres" value={usuario.nombre} className="mb-4"/></Col>
                                                    <Col xl={6}><Form.Control type="text" disabled readOnly title="Apellidos" value={usuario.apellido} className="mb-4"/></Col>
                                                    <Col xl={6}><Form.Control type="text" disabled readOnly title="RUT" value={rut} className="mb-4"/></Col>
                                                    <Col xl={6}><Form.Control type="text" disabled readOnly title="Email" value={usuario.email} className="mb-4"/></Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    ) : (
                                        // Modo Edición
                                        <Form>
                                            <Row>
                                                <Col xl={4}>
                                                    <div className="mc-user-avatar-upload">
                                                        <div className="mc-user-avatar">
                                                            <img src="images/454394643_1066147051562693_6889527070463660169_n.jpg" alt="avatar" />
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col xl={8}>
                                                    <Row>
                                                        <Col xl={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Nombres</Form.Label>
                                                                <Form.Control 
                                                                    type="text" 
                                                                    name="nombre"
                                                                    value={editData.nombre || ""}
                                                                    onChange={handleEditChange}
                                                                    placeholder="Ingrese su nombre"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xl={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Apellidos</Form.Label>
                                                                <Form.Control 
                                                                    type="text" 
                                                                    name="apellido"
                                                                    value={editData.apellido || ""}
                                                                    onChange={handleEditChange}
                                                                    placeholder="Ingrese su apellido"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xl={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>RUT</Form.Label>
                                                                <Form.Control 
                                                                    type="text" 
                                                                    name="rut"
                                                                    value={editData.rut}
                                                                    onChange={handleEditChange}
                                                                    isInvalid={!!rutError}
                                                                    placeholder="Ej: 11.111.111-1 o 1111111-1"
                                                                />
                                                                {rutError && <Form.Control.Feedback type="invalid">{rutError}</Form.Control.Feedback>}
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xl={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Email</Form.Label>
                                                                <Form.Control 
                                                                    type="email" 
                                                                    name="email"
                                                                    value={editData.email || ""}
                                                                    onChange={handleEditChange}
                                                                    placeholder="Ingrese su email"
                                                                    isInvalid={!!emailError}
                                                                />
                                                                {emailError && (
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {emailError}
                                                                    </Form.Control.Feedback>
                                                                )}
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xl={12}>
                                                            <Button 
                                                                variant="success" 
                                                                onClick={handleGuardarDatos}
                                                                disabled={disableEditButton || emailError}
                                                                style={{ marginRight: '10px' }}
                                                            >
                                                                <i className='material-icons' style={{ fontSize: '16px', marginRight: '5px' }}>save</i>
                                                                Guardar Cambios
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Form>
                                    )}
                                </div>
                               
                            </Tab>
                            <Tab eventKey="password" title="Cambiar Password" className="mc-tabpane password">
                            <form className="mc-auth-form" onSubmit={handleSubmit} >
                                <div className="mc-tab-card">
                                    <h6 className="mc-tab-card-title">Cambiar Password</h6>
                                    <h5 className="mc-duel-text-title">Su nueva contraseña debe cumplir las siguientes políticas de seguridad:</h5>
             
                                        <ul className="mc-user-metalist">
                                                                    <li><i className="material-icons">check</i><span>Mínimo de 8 carácteres.</span></li>
                                                                    <li><i className="material-icons">check</i><span>Contener al menos una letra Mayúscula y una Minúscula.</span></li>
                                                                    <li><i className="material-icons">check</i><span>Contener al menos un caracter especial (#?!@$%^&+*.-)</span></li>
                                                                    <li><i className="material-icons">check</i><span>Contener al menos un número.</span></li>
                                                                    <li><i className="material-icons">check</i><span>No incluir el nombre de la cuenta de usuario (email).</span></li>
                                                                    <li><i className="material-icons">check</i><span>No incluir su nombre de pila.</span></li>

                                                                </ul>
                                    <Row>
                                        <Col xs={12} md={12}><IconFieldComponent icon="lock" type="password" placeholder="Password Actual" classes="w-100 h-lg mb-4" passwordVisible /></Col>
                                        <Col xs={12} md={6}><IconFieldComponent icon="add_moderator" type="password" placeholder="Nueva Password" name="password" onChange={handleInputChange}    onKeyUp={handleValidation} classes="w-100 h-lg mb-4" passwordVisible />
                                        {passwordError !== "" ?
                                        <p className="mt-0 px-2 py-1 bg-red-50  text-red-600 border border-red-100 rounded text-sm">{passwordError}</p>
                                        : null }
                                        
                                        </Col>
                                        <Col xs={12} md={6}><IconFieldComponent icon="verified_user" type="password" placeholder="Confirmar Password" name="confirmPassword"  onChange={handleInputChange}   onKeyUp={handleValidation}  classes="w-100 h-lg mb-4" passwordVisible />
                                        { confirmPasswordError !== "" ?
                                            <p className="mt-0 px-2 py-1 bg-red-50  text-red-600 border border-red-100 rounded text-sm">{confirmPasswordError}</p>
                                            : null }
                                        </Col>
                                    </Row>
                                </div>
                                <ButtonComponent className="mc-btn primary" icon="verified" text="Cambiar Password" />
                            </form>    
                            </Tab>
                            
                        </Tabs>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    )
}